import UserGuideTooltip from "@/components/UserGuideTooltip";
import classNames from "classnames";
import { useCallback, useState } from "react";
import { Else, If, Then } from "react-if";
import HBIcon from "../../HBIcon";
import EditGroup from "../EditGroup";
import styles from "./index.module.less";

export default function CreateGroup({ className, onCreate, type }) {
  const [edit, setEdit] = useState(false);

  const onEdit = useCallback(async () => {
    setEdit(true);
  }, []);

  const onCancel = useCallback(() => {
    setEdit(false);
  }, []);

  const onOk = useCallback(
    async (values) => {
      const success = onCreate && (await onCreate(values));
      success && setEdit(false);
    },
    [onCreate]
  );

  return (
    <UserGuideTooltip
      className={styles.tooltip}
      localStorageKey={(userId) => `_PINIT_FRONT_USER_GUIDE_SIGN_${userId}_13_`}
      placement="bottomLeft"
      type="hover"
      title="开始创建分组，管理你的关注吧"
    >
      <div className={classNames([styles.container, className])}>
        <If condition={edit}>
          <Then>
            <EditGroup
              onCancel={onCancel}
              onOk={onOk}
              okButtonProps={{
                "data-gd-click": "button_click",
                "data-button-name": `确定创建分组_${type}`,
              }}
            />
          </Then>
          <Else>
            <div className={styles.buttonContainer}>
              <div
                className={styles.button}
                onClick={onEdit}
                data-gd-click="button_click"
                data-button-name={`创建分组_${type}`}
              >
                <HBIcon className={styles.icon} type="plus" />
                <div className={styles.text}>创建分组</div>
              </div>
            </div>
          </Else>
        </If>
      </div>
    </UserGuideTooltip>
  );
}
